import { Component } from '@angular/core';

@Component({
    selector: "app-header",
    templateUrl: "./app.header.component.html"
})
export class HeaderComponent {
    
}


// WEBPACK FOOTER //
// C:/pgutev/work/WEBCAM/src/app/shared/app.header.component.ts